function baseEvents() {
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    if (
      $(".type-category").length ||
      $(".product").length ||
      $(".type-search").length ||
      $(".type-manufacturer-detail").length
    ) {
      productRepo();
      repoTopBannerCategory();
    }
  });

  document.addEventListener("ShoptetDOMPageContentLoaded", function () {
    if (
      $(".type-category").length ||
      $(".type-search").length ||
      $(".product").length ||
      $(".type-manufacturer-detail").length
    ) {
      productRepo();
      repoTopBannerCategory();
    }
  });

  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    if ($(".product").length) {
      productRepo();
      repoTopBannerCategory();
    }
  });

  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    repositionContentAdvancedModal();

    // var continueShopping = `
    // 		<div class="extra step step--first"><button class="next-step-back back-to-shop js-continue-shopping" style="
    // 		"></button></div>
    // 	`;
    // $(".advanced-order > .extra-item .extra-content").append(continueShopping);

    // $(document).on("click", ".js-continue-shopping", function () {
    //   $("#cboxClose").trigger("click");
    // });
  });

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    setTimeout(() => {
      if ($(".id--9").length) {
        // Reorder basket step 1 elements
        reorderBasketElements();
      }
    }, 10);
  });
}
